// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wd x2","ribbon":"we x_","title":"wf x4","seasons":"wh x9","genres":"wi x-","buttonWrapper":"wj x6","button":"wk x7"};